<template>
  <button
    class="
      rounded-customRadius
      py-2
      px-4
      outline-none
      focus:outline-none
      bg-primary-color
      text-primary-text-color
      border border-primary-color
      hover:bg-white hover:text-primary-hover-text-color
    "
    style="transition: all 0.15s ease 0s"
    :type="type"
    :name="name"
    @click="onClick"
  >
    <slot>Button</slot>
  </button>
</template>

<script >
export default {
  name: "Btn",
  props: {
    type: String,
    name: {
      default: "button",
      type: String,
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>